import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getAuthToken } from "../../../util/authToken";

const API_BASE_URL = process.env.REACT_APP_HOST_URL;

function useGetZoneMarkup(id, refresh) {

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        //call everytime zone markup modal is opened to get the latest file
        setIsLoading(true);
        fetch(API_BASE_URL + "/getEquipmentZoneMarkings", {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                Accept: "application/pdf",
                Authorization: `Bearer ${getAuthToken()}`
            },
            body: JSON.stringify({ "file_name": `${id}.pdf` }),
            // headers: baseHeaders,
            // credentials: 'include'
        }).then((response) => {
            if (response.ok) {
                return response.blob();
            } else {
                throw new Error('Network response was not ok');
            }
        })
        .then((blob) => {
            // Create a URL for the Blob and trigger a download
            const url = window.URL.createObjectURL(blob);
            console.log("File fetched successfully:", url);
            setData(url);
            // const a = document.createElement('a');
            // a.href = url;
            // a.download = `${id}_zone_markings.pdf`; // Set the file name
            // document.body.appendChild(a);
            // a.click();
            // a.remove();
            // window.URL.revokeObjectURL(url); // Clean up the URL object
        })
        .catch((error) => {
            console.log(error);
            toast.error("Error fetching zone markup file. Please try again later.");
            setIsError(true);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [id]);

    return {
        data,
        isLoading,
        isError,
    };
}
export default useGetZoneMarkup;